export default {
    currencies(state) {
        return state.list
    }
}
